import { RouterLink } from 'components/RouterLink';
import useAccountIdRoute from 'hooks/useAccountIdRoute';

export function CLIClusterRescanDisabledTooltip() {
  const addClusterPath = useAccountIdRoute(
    `/orgs/:orgId/accounts/:accountId/clusters/new`,
  );
  return (
    <div className="flex flex-col gap-1">
      <span>
        {
          'Rescan is not available for clusters added via Chkk CLI. Instead you can run '
        }
        <code className="text-label bg-neutral-600 border border-solid border-neutral-border font-monospace-body rounded py-0 px-[2px]">
          chkk cluster collect
        </code>
        {' again to refresh the results.'}
      </span>
      <span>
        {
          'To enable Rescan and receive periodic updates through automatic scans, '
        }
        <RouterLink
          to={addClusterPath}
          className="text-label-bold hoverable-link"
        >
          {'Install Chkk K8s Connector'}
        </RouterLink>
        {
          ' in your cluster. Once the first scheduled scan is completed, you can request rescans here.'
        }
      </span>
    </div>
  );
}
